import React, { useEffect } from "react";
import OnePage from "./components/OnePage";

import "./index.css";

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  return (
    <div className="flex flex-col overflow-hidden bg-black">
      {/*
      <Navbar />
      <HeroModern />
      <ServicesDetail />
      <AboutSection />
      <ValueProp />
      <ContactSection />*/}

      <OnePage />

{/* <Hands /> */}
{/* <Slogan /> */}
{/* <Hero /> */}
{/* <About /> */}
{/* <Newsletter /> */}
{/* <Skills /> */}
{/* <Master /> */}
{/* <Footer /> */}
    </div>
  );
}

export default App;
